import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Link, useLocation } from "react-router-dom";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import Loader from "./Loader";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";
import { GET_DIET_SCHOOLS_TRAINERS_LIST } from "./AllApi";
import ExportToExcel from "./ExportToExcel";

const SchoolTrainerList = () => {
  const location = useLocation();

  // const dietName = localStorage.getItem("diet_name");
  const schoolId =
    location.state?.schoolId || location.state.dietDetails.schoolId || "";
  const dietId =
    location.state?.dietId || location.state.dietDetails.dietId || "";
  // console.log("schoolId: ", schoolId);
  const schoolName =
    location.state?.schoolName || location.state.dietDetails.schoolName || "";
  const school_loc =
    location.state?.school_loc || location.state.dietDetails.school_loc || "";
  const dietLoc =
    location.state?.dietLoc || location.state.dietDetails.dietLoc || "";
  const dietName =
    location.state?.dietName || location.state.dietDetails.dietName || "";
    
  const dietDetails = {
    schoolId: schoolId,
    dietName: dietName,
    dietLoc: dietLoc,
    dietId: dietId,
    schoolName: schoolName,
    school_loc: school_loc,
  };
  // console.log("DietName: ", dietName);

  const [Data, SetData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const userRole = localStorage.getItem("userRole");

  const selectedSection = localStorage.getItem("selectedSection");

  useEffect(() => {
    const DIET_SCHOOLS_LIST_API = GET_DIET_SCHOOLS_TRAINERS_LIST(schoolId);
    setLoading(true);
    // console.log('data is fetching...');
    const fetchData = async () => {
      var token = localStorage.getItem("authToken");
      try {
        const response = await fetch(DIET_SCHOOLS_LIST_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          // console.log("TrainerList : ", data);
          SetData(data.schoolTrainers);
          //   console.log("data is fetched...");
        }
      } catch (err) {
        console.error("error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(Number(pageNumber));
  };

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageCount));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };

  const sortData = (a, b) => {
    const keyA =
      typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
    const keyB =
      typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

    if (!isNaN(keyA) && !isNaN(keyB)) {
      return sortDirection === "asc" ? keyA - keyB : keyB - keyA;
    }

    if (sortDirection === "asc") {
      return keyA.localeCompare(keyB);
    } else {
      return keyB.localeCompare(keyA);
    }
  };

  // const filteredData = Data.filter((data) =>
  //   Object.values(data).some((value) =>
  //     value.toString().toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
  const filteredData = Data.filter((data) =>
    Object.values(data).some(
      (value) =>
        value != null &&
        value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const sortedData = sortBy
    ? filteredData
        .slice(indexOfFirstItem, indexOfLastItem)
        .sort((a, b) => sortData(a, b))
    : filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const totalItems = filteredData.length;
  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container mt-5">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <Link
                  to="/dietParticularData"
                  className="prevPage"
                  state={{
                    dietId: dietId,
                    dietName: dietName,
                    dietLoc: dietLoc,
                  }}
                >
                  {dietName}, {dietLoc}
                </Link>
                <img
                  src={nextArrow}
                  alt="nextArrow"
                  height={40}
                  className="mt-1"
                />
                <p className="currentPage">
                  {schoolName}, {[school_loc]}
                </p>
              </ol>
            </nav>
          </div>
          <section className="schoolLissectionn ">
            <div className="container">
              <div>
                <div className="schListHeader_div">
                  <p className="schListHeader_text">Trainer List</p>
                  <div className="d-flex">
                    <div>
                      <ExportToExcel
                        data={Data}
                        fileName={`${dietName}_${schoolName}_Teacher_List`}
                        // fileName="Diet_Schools_Teacher_List"
                        sheetName="Teachers"
                        columns={[
                          { key: "tra_name", alias: "Teacher Name" },
                          { key: "tra_phone", alias: "Teacher Mobile" },
                          { key: "tra_email", alias: "Teacher Email" },
                          { key: "tra_address", alias: "Teacher Address" },
                          // { key: "school_name", alias: "School Name" },
                          // { key: "school_loc", alias: "Address" },
                          // { key: "principal_name", alias: "Principal Name" },
                          // { key: "princi_mobile", alias: "Principal Mobile" },
                          // { key: "principal_email", alias: "Principal Email" },
                        ]}
                      />
                    </div>

                    <div className="card searchBarCard">
                      <div
                        className="card-body d-flex"
                        style={{ padding: "0rem 1rem" }}
                      >
                        <input
                          className="form-control searchBar_input"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {sortedData?.length < 0 || sortedData?.length === 0 ? (
                <>
                  <p className="progressMainTitle text-center ">
                    No data available
                  </p>
                </>
              ) : (
                <div className="card schoolListTableDiv">
                  <div
                    className="card-body table-responsive"
                    style={{
                      maxHeight: "700px",
                      // height: "698px",
                      overflow: "hidden",
                    }}
                  >
                    <table className="table table-borderless table-responsive">
                      <thead
                        style={{ marginBottom: "20px" }}
                        className="thead_div pb-4 ps-4"
                      >
                        <tr className="align-middle">
                          <th scope="col" className="thead_div_row">
                            Sr.No.
                          </th>
                          <th scope="col" className="thead_div_row pb-4 ps-4">
                            <span style={{ margin: "5px", display: "flex" }}>
                              <span style={{ marginTop: "3px" }}>Trainer</span>

                              <span>
                                <button
                                  className="sort_button"
                                  type="button"
                                  onClick={() => handleSort("tra_name")}
                                >
                                  <img
                                    className="desc"
                                    src={
                                      sortDirection === "asc" &&
                                      sortBy === "tra_name"
                                        ? downArrow
                                        : upArrow
                                    }
                                    alt="Sort Button"
                                  />
                                </button>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="thead_div_row pb-4 ps-4"
                            // style={{ width: "20%" }}
                          >
                            Trainer Mobile
                          </th>
                          <th
                            scope="col"
                            className="thead_div_row pb-4 ps-4"
                            // style={{ width: "20%" }}
                          >
                            Trainer Email
                          </th>

                          <th scope="col" className="thead_div_row pb-4 ps-4">
                            <span style={{ margin: "5px", display: "flex" }}>
                              <span style={{ marginTop: "3px" }}>Location</span>

                              <span>
                                <button
                                  className="sort_button"
                                  type="button"
                                  onClick={() => handleSort("tra_address")}
                                >
                                  <img
                                    className="desc"
                                    src={
                                      sortDirection === "asc" &&
                                      sortBy === "tra_address"
                                        ? downArrow
                                        : upArrow
                                    }
                                    alt="Sort Button"
                                  />
                                </button>
                              </span>
                            </span>
                          </th>
                          {/* <th
                            scope="col"
                            className="thead_div_row pb-4 ps-4"
                            // style={{ width: "20%" }}
                          >
                            Assessment attempts
                          </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {sortedData.map((data, index) => (
                          <tr key={index}>
                            <td style={{ paddingBottom: "28px" }}>
                              <span
                                className="header_srNo"
                                style={{ float: "left" }}
                              >
                                {index + indexOfFirstItem + 1}
                              </span>
                            </td>
                            <td>
                              <div
                                style={{ textAlign: "left" }}
                                className="d-flex"
                              >
                                <Link
                                  to="/teacherParticularData"
                                  style={{ textDecoration: "none" }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "trainer_id",
                                      data.tra_id
                                    );
                                    localStorage.setItem(
                                      "trainer_name",
                                      data.tra_name
                                    );
                                  }}
                                  state={{
                                    trainerId: data.tra_id,
                                    referrer: "/diet",
                                    dietDetails: dietDetails,
                                  }}
                                >
                                  <img
                                    src={
                                      data.tra_image === null ||
                                      data.tra_image === ""
                                        ? profile_pic
                                        : data.tra_image
                                    }
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                    }}
                                    onError={(e) => {
                                      e.target.src = profile_pic;
                                    }}
                                    alt="profilePic"
                                  />

                                  <span className="allocatedTeacher ms-2">
                                    {data.tra_name}
                                  </span>
                                </Link>
                              </div>
                            </td>
                            <td>
                              <span
                                style={{ float: "left" }}
                                className="location_text"
                              >
                                {`${data.tra_phone}`}
                              </span>
                            </td>
                            <td>
                              <span
                                style={{ float: "left" }}
                                className="location_text"
                              >
                                {`${data.tra_email}`}
                              </span>
                            </td>
                            <td>
                              <span
                                style={{ float: "left" }}
                                className="location_text"
                              >
                                {`${data.tra_address}`}
                              </span>
                            </td>
                            {/* <td><span
                              style={{textAlign:'center'}}
                                className="location_text"
                              >
                                {data.tra_assessment_attempt ? data.tra_assessment_attempt :"-"}
                     
                              </span>

                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="pagination row">
                    <div className="result_msg col-12 col-lg-7 col-sm-7 col-md-7">
                      <p
                        className="result_msg_text"
                        style={{ marginBottom: "0px" }}
                      >
                        Displaying {rangeEnd} results of {totalItems}
                      </p>
                    </div>

                    <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                      <div
                        className="d-flex"
                        style={{
                          alignItems: "center",
                          marginRight: "10px",
                        }}
                      >
                        <p className="paginate_msg_text">Page</p>
                        <div>
                          <select
                            // className="form-select pageDropdown"
                            className="select_page"
                            style={{
                              marginRight: "8px",
                              // marginLeft: "16px",
                            }}
                            value={currentPage}
                            onChange={(e) => handlePageChange(e.target.value)}
                          >
                            {Array.from(
                              { length: pageCount },
                              (_, i) => i + 1
                            ).map((pageNum) => (
                              <option value={pageNum} key={pageNum}>
                                {pageNum}&nbsp;
                              </option>
                            ))}
                          </select>
                        </div>
                        <p className="paginate_msg_text">of {pageCount}</p>
                      </div>

                      <div className=" d-flex">
                        <button
                          type="button"
                          className="bton"
                          onClick={prevPage}
                          disabled={currentPage === 1}
                        >
                          <img
                            src={prevArrow}
                            alt="prev"
                            className="arrow_btn"
                          />
                        </button>

                        <button
                          type="button"
                          className="bton"
                          onClick={nextPage}
                          // disabled={indexOfLastItem >= filteredData.length}
                          disabled={currentPage === pageCount}
                        >
                          <img
                            src={nextArrow}
                            alt="next"
                            className="arrow_btn"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default SchoolTrainerList;
